import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5a26198f")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return _withDirectives((_openBlock(), _createBlock("span", {
    class: ["font-icon type", _ctx.textClass],
    style: {"display":"inline-block"}
  }, [
    _createVNode("i", {
      class: _ctx.iconClass,
      style: {"font-size":"1.5rem","position":"relative","top":"3px"}
    }, null, 2),
    _createTextVNode(" " + _toDisplayString(_ctx.role), 1)
  ], 2)), [
    [
      _directive_tooltip,
      _ctx.$t(_ctx.tooltip),
      void 0,
      { top: true }
    ]
  ])
})